import { render, staticRenderFns } from "./checkbomsaferout.vue?vue&type=template&id=308f9287&scoped=true&"
import script from "./checkbomsaferout.vue?vue&type=script&lang=js&"
export * from "./checkbomsaferout.vue?vue&type=script&lang=js&"
import style0 from "./checkbomsaferout.vue?vue&type=style&index=0&id=308f9287&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308f9287",
  null
  
)

export default component.exports